import { useTranslation } from "react-i18next"
import { AreaLayout, MainContentPaddingTypes, NewButtonList, NewModal, NewSectionModal, PageHeader, ToggleBox } from "../../../../Components"
import { colors, fonts, frames, glyphs, useMediaQuery } from "../../../../Styles"
import { Pages } from "../../../../Navigation/root"
import { memo, Reducer, useEffect, useMemo, useReducer, useState } from "react"
import { EsfLocation, TestData as esfSections, EsfSectionsInfo, StationInfo } from "../../../../Services/Agrisys_GqlDataCaller/WalkThroughDataCalls/getEsfStructureCall"
import { ButtonTypes, SystemTypes } from "../../../../Definitions"
import { Graph_QL, Location, useSection, useSystem } from "../../../../Services"
import { useAppSelector } from "../../../../Store"
import { useParams } from "react-router"
import { contents, getButtonStyles } from "../Freeda_lf/freeda_lf_sections"
import { currentEsfViewTypes, EsfContext, EsfDispatcherT, EsfReducer, IEsfContext } from "../../../../Components/EsfWalkThrough/_EsfWalkThrough/EsfContext"
import ESF_STATIONLIST from "../../../../Components/EsfWalkThrough/SubComponents/EsfStationList"
import BluePrintModal from "../../../../Components/bluePrintModal"
import EsfSectionModal from "../../../../Components/EsfWalkThrough/Modals/esf_sectionModal"
import EsfStationModal from "../../../../Components/EsfWalkThrough/Modals/esf_stationModal"

export default function Freeda_esf_sections() {
  const { t } = useTranslation()
  const mobileXs = useMediaQuery(`(max-width: 450px)`);
  const [activeLocation, setActiveLocation] = useState<EsfLocation | undefined>();
  const [activeStation, setActiveStation] = useState<StationInfo | undefined>();
  const [currentViewType, setCurrentViewType] = useState< "editSections" | "attention" | "yesterday" | "today" | "basic">("today")
  const [currentModalType, setCurrentModalType] = useState<"newSectionModal" | "blueprintModal" | undefined>(undefined)

  // #region | GraphQL
  const farm = useAppSelector(({ activeData }) => activeData.farm) ?? "";
  const { domain, connection } = useMemo(() => {
    let domain = Graph_QL.ObjToString({ domain: farm });
    let connection = Graph_QL.create({ domain: farm });
    return { domain, connection };
  }, [farm]);

  const { call: getLfSectionsInfo, data: lfSectionsState } = useSection(connection);
  const { call: getSystem, data: systemState } = useSystem(connection)
  const { systemId: urlSystemId } = useParams();
  const systemId = Number(urlSystemId)    

  // Data gets
  useEffect(() => {
    getLfSectionsInfo({ ids: [systemId] }, connection);
    getSystem({ ids: [systemId] }, connection)
  // eslint-disable-next-line
  }, [])
  
  // System
  const system = useMemo(() => (systemState[domain] ? systemState[domain].data.find(s => s.system_id === systemId) : undefined), [domain, systemId, systemState])
  
  // Locations = Sections
  const locations = esfSections.map(a => a.section_locations)
  
  // Current Location = current section
  // const { index: currentSectionIndex, name: currentSectionName, pens: currentSectionPens } = filteredBySystemIdSectionIndex(domain, systemId, activeLocation?.location_id ?? 0)
  
  // Current Station
  // const { index: currentPenIndex, name: currentPenName } = getPensFromSectionIdPenIndex(domain, systemId, activeLocation?.location_id ?? 0, activeStation?.station_id ?? 0)

  // Animals
  // const animalsInSection = useAppSelector((state) => {if (currentSectionPens.length) {return selectByLocations(state.graphQlData.animals, currentSectionPens.map((location) => location.location_id))}}) 

  // Sections Info (skal slettes)
  const sectionInfo = useMemo(() => {
    if (!locations) return { currentSectionIndex: -1, currentSectionName: "", currentSectionStations: [] };
    const currentSectionIndex = locations.findIndex(s => s.location_id === activeLocation?.location_id);
    const currentSectionName = locations?.[currentSectionIndex]?.name
    const currentSectionStations = locations?.[currentSectionIndex]?.stations ?? [];

    return {
      currentSectionIndex,
      currentSectionName,
      currentSectionStations
    }
  }, [activeLocation?.location_id, locations])

  // Station Info (skal slettes)
  const stationInfo = useMemo(() => {
    if (!sectionInfo) return { currentStationIndex: -1, currenStationName: "" };
    const currentStationIndex = sectionInfo.currentSectionStations.findIndex(station => station.station_id === activeStation?.station_id);
    const currenStationName = sectionInfo.currentSectionStations?.[currentStationIndex]?.name
    
    return {
      currentStationIndex,
      currenStationName
    }
  }, [activeStation?.station_id, sectionInfo])
  
  const [_state, dispatch] = useReducer<Reducer<IEsfContext, EsfDispatcherT>>(EsfReducer, {
    farm: farm,
    domain: domain,
    connection: connection,
    system: system,
    sections: locations,
    currentStationViewType: currentEsfViewTypes.basic,
    error: { Elementid: 0, errorText: "" }
  } as IEsfContext);

  // #region | Button List
  const ButtonRow = memo(({ editTable }: { editTable: boolean }) => {
    const [contentsRes, icons, onClicks] = contents(
      () => { setCurrentModalType("newSectionModal") },
      () => { setCurrentViewType("editSections") },
      () => { setCurrentViewType("basic")},
      t("buttons.add", { defaultValue: "Add" }),
      t("buttons.edit", { defaultValue: "Edit" }),
      t("buttons.cancel", { defaultValue: "Cancel" }),
      editTable
    )
      
    return (
      <NewButtonList 
        contents={contentsRes} 
        onClick={(i) => { onClicks[i]?.() }}
        buttonType={ButtonTypes.tableButton}
        startEnhancers={icons}
        disabled={editTable ?[false, false, true, true] : [false, false] }
        overrides={(index) => {
          const { backgroundColor, opacity } = getButtonStyles(index, editTable);
          return {
            baseButton: { backgroundColor: backgroundColor },
            disabledStyles: { opacity: opacity }
          }
        }}
      />
    )
  })
  // #endregion

  // #region | Section Click
  const handleSectionClick = (location_id: number) => {  
    const location = locations.find(s => s.location_id === location_id);
    if (!location) return;
  
    setActiveLocation(location);
  };

  // const Section = memo(({ station }: { station: StationInfo }) => {
  //   if (!activeLocation || !system) return null;
  //   return <EsfSectionModal connect={{connection: connection, domain: domain, farm: farm}} system={system} activeSectionId={activeLocation?.location_id} onStationSelected={(station) => setActiveStation(station.station_id)} stations={sectionInfo.currentSectionStations} pen={[]} view={sectionTab}/> // SECTION POPUP
  // });
  
  return (
    <frames.Page_inner>
      <PageHeader
        topHeader={system?.name}
        subHeader={t(`menuHeaders.${Pages.freeda_esf_sections}`, {defaultValue: "sections"})}
      />
      <frames._page_inner_content style={{ zIndex: currentViewType === "editSections" ? "9999" : "0" }}>
        <AreaLayout
          headerArea={<p style={{ ...fonts.header, ...fonts.fontSize3, color: colors.greyLightTertiary, marginBottom: "5px" }}>{locations?.length} {t("locationFeederPages.sections.sections", { defaultValue: "sections" })}</p>}
          buttonArea={<ButtonRow editTable={currentViewType === "editSections" ? true : false} />}
          topArea={
            <frames.ToggleBox style={{ columnGap: mobileXs ? "10px" : "30px" }}>
              <ToggleBox disabled={currentViewType === "editSections" ? true : false} text={t("feed.general.remainingToday", { defaultValue: "remaining today" })} icon={glyphs.TimeToday({ size: "17px" })} onChange={() => setCurrentViewType(currentViewType === "today" ? "basic" : "today")} isChecked={currentViewType === "today" ? true : false} />
              <ToggleBox disabled={currentViewType === "editSections" ? true : false} text={t("feed.general.remainingYesterday", { defaultValue: "remaining yesterday" })} icon={glyphs.TimeYesterday({ size: "17px" })} onChange={() => setCurrentViewType(currentViewType === "yesterday" ? "basic" : "yesterday")} isChecked={currentViewType === "yesterday" ? true : false} />
              
              <ToggleBox disabled={currentViewType === "editSections" ? true : false} text={t("systemControls.general.attentions", { defaultValue: "attentions" })} icon={<div style={{ marginTop: "1px" }}><glyphs.Attention size="17px" /></div>} onChange={() => setCurrentViewType(currentViewType === "attention" ? "basic" : "attention")} isChecked={currentViewType === "attention" ? true : false} />
            </frames.ToggleBox>
          }
          contentArea={
            <EsfContext.Provider value={{ state: _state, dispatch }}>
              {((locations.length === 0 || locations === undefined)) ? <p style={{...fonts.paragraph, ...fonts.fontSize4, color: colors.greyDarkPrimary}}>{t("locationFeederPages.sections.noSections", {defaultValue: "No sections found"})}</p> : <></>}
              <frames.PenListsWrapper style={{ justifyContent: mobileXs ? "center" : "start" }}>
                {system && locations?.map((location, index) => (
                  <div key={index} style={{ height: "fit-content", width: "fit-content" }} onClick={() => { handleSectionClick(location.location_id)}}>
                    <ESF_STATIONLIST
                      key={location.location_id}
                      section={location}
                    />
                  </div>
                ))}
              </frames.PenListsWrapper>
            </EsfContext.Provider>
          }
          bluePrint={{
            disabled: currentViewType === "editSections" ? true : false,
            onClick: () => setCurrentModalType("blueprintModal"),
            startEnhancer: glyphs.BluePrint({})
          }}
        />
      </frames._page_inner_content>
      
      {/* Section/Station Modal */}
      {currentViewType !== "editSections" && system && (activeLocation || activeStation) ?
        <NewModal
          header={activeStation !== undefined ? `${t("locationFeederPages.locationFeeder.pen", { defaultValue: "Pen" })} ${stationInfo.currenStationName}` : sectionInfo.currentSectionName}
          subHeader={activeStation !== undefined ? `${system.name} ${sectionInfo.currentSectionName}` : `${system.name}`}
          overrides={{
            backgroundColor: colors.greyLightTertiary,
            mainContentPadding: MainContentPaddingTypes.primary,
            mainContentScroll: true
          }}
          predefinedButtons={{
            onClose: () => {
              setActiveLocation(undefined)
              if (activeStation !== undefined) setActiveStation(undefined)
            },
            onGoBack: activeStation !== undefined ? () => setActiveStation(undefined) : undefined,
            onPrev: () => activeStation !== undefined
              ? setActiveStation(sectionInfo.currentSectionStations[(stationInfo.currentStationIndex - 1 + sectionInfo.currentSectionStations?.length) % sectionInfo.currentSectionStations.length])
              : setActiveLocation(locations[0]),
            onNext: () => activeStation !== undefined
              ? setActiveStation(sectionInfo.currentSectionStations[(stationInfo.currentStationIndex + 1) % sectionInfo.currentSectionStations.length])
              : setActiveLocation(locations[0])
          }}
          mainContent={
            <div style={{ width: "735px", display: "flex", flexDirection: "column", alignItems: "center" }}>
              {activeStation === undefined && activeLocation ? (
                <EsfSectionModal
                  connect={{ connection: connection, domain: domain, farm: farm }}
                  system={system}
                  onStationSelected={(station) => setActiveStation(sectionInfo.currentSectionStations.find(s => s.station_id === station))}
                  stations={sectionInfo.currentSectionStations}
                  pen={[]}
                />
              ) : activeStation !== null ? (
                  <EsfStationModal activeStation={activeStation}/> // STATION POPUP
              ) : null
              }
            </div>
          }
        />
      : <></>} 

      {/* Blue Print Modal */}
      {currentModalType === "blueprintModal" && system && (
        <BluePrintModal system={system} onClose={() => setCurrentModalType(undefined)}/>
      )}
    
      {/* New Section Modal */}
      {currentModalType === "newSectionModal" && (
        <NewSectionModal 
          closeModal={() => {setCurrentModalType(undefined);}}
          systemId={systemId}
          systemType={SystemTypes.freedaEsf_WalkThrough}
        />
      )}

    </frames.Page_inner>
  )
}

